import { type FC, type ComponentProps, lazy, Suspense } from 'react';

const BuyerIncentivesBannerCompact = lazy(
    () =>
        import(
            /* webpackChunkName: "BuyerIncentivesBannerCompact" */ './BuyerIncentivesBannerCompact.tsx'
        )
);

export const BuyerIncentivesBannerCompactLazy: FC<
    ComponentProps<typeof BuyerIncentivesBannerCompact>
> = props => (
    <Suspense fallback={null}>
        <BuyerIncentivesBannerCompact {...props} />
    </Suspense>
);
